import React, { Fragment, useState } from 'react';
import { PageTitle } from '../../../components/PageTitle';
import { useTranslation } from 'react-i18next';

import { FloatingActionsButtons } from '../../../components/FloatingActionsButtons';
import { CreateAction } from '../../../components/FloatingActionsButtons/components/CreateAction';
import { UpsertAgentDialog } from '../dialogs/UpsertAgentDialog';
import { useNavigate } from 'react-router';
import { ManagedDataTable } from '../../../components/ManagedDataTable';
import { useGetAgents } from '../../../reactQuery/Agents/agents';
import { IManagedDataTable } from '../../../components/ManagedDataTable/interfaces';
import { Agent } from '../../../api/agentsApi/interfaces';
import { columns } from './helpers';
import { DATA_TABLE_STORAGE_KEYS } from '../../../constants';

export const AgentsOverview: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showCreateDialog, setShowCreateDialog] = useState<boolean>(false);

  const onRowClick = (row: Agent): void => {
    navigate(`/agents/${row.id}`);
  };

  return (
    <Fragment>
      <PageTitle
        title={t('agents:title')}
        subTitle={t('agents:subTitle')}
        space
      />
      <ManagedDataTable
        query={useGetAgents as IManagedDataTable<Agent>['query']}
        columns={columns}
        onRowClick={onRowClick}
        storageKey={DATA_TABLE_STORAGE_KEYS.agents}
        initialSort={{ field: 'lastName', sort: 'asc' }}
      />
      <UpsertAgentDialog
        show={showCreateDialog}
        onClose={() => setShowCreateDialog(false)}
      />
      <FloatingActionsButtons>
        <CreateAction onClick={() => setShowCreateDialog(true)} />
      </FloatingActionsButtons>
    </Fragment>
  );
};
